import { QueryClient, useQuery, UseQueryResult } from '@tanstack/react-query';
import { klwAxios, setKringloopwijzerId } from 'helpers/api';
import { CallContextModel } from 'pages/shared/models/callcontext';

export const CALL_CONTEXT_QUERY_KEY = ['CallContext'];

export const getCallContextModel = (): Promise<CallContextModel> => {
  const klwId = localStorage.getItem('KringloopwijzerId');
  const proxyKvk = localStorage.getItem('ProxyKvk');
  if (!!klwId && !proxyKvk) klwAxios.defaults.headers.common['Kringloopwijzer-Id'] = klwId;
  if (!!klwId && !!proxyKvk) {
    klwAxios.defaults.headers.common['Kringloopwijzer-Id'] = klwId;
    klwAxios.defaults.headers.common['Kvk-Proxy'] = proxyKvk;
  }

  return klwAxios.get<CallContextModel>('Auth/GetCallContextModel').then(res => {
    setKringloopwijzerId(res.data.kringloopwijzerId);
    localStorage.setItem('klwJaar', `${res.data.kringloopwijzerJaar}`);
    localStorage.setItem('klwPilotId', `${res.data.kringloopwijzerPilotId}`);
    if (!res.data.gebruikerIsDeelnemer) klwAxios.defaults.headers.common['Kvk-Proxy'] = localStorage.getItem('ProxyKvk');
    return res.data;
  });
};

export const useGetCallContext = (enabled = true): UseQueryResult<CallContextModel> => {
  return useQuery({
    queryKey: CALL_CONTEXT_QUERY_KEY,
    enabled,
    queryFn: getCallContextModel,
  });
};

export const refreshCallContext = async (queryClient: QueryClient): Promise<CallContextModel> => {
  await queryClient.invalidateQueries({ queryKey: CALL_CONTEXT_QUERY_KEY, refetchType: 'none' });
  return queryClient.fetchQuery({
    queryKey: CALL_CONTEXT_QUERY_KEY,
    queryFn: getCallContextModel,
    staleTime: 0,
  });
};
